import React from 'react';
import './OverlayBienvenida.css';

const OverlayBienvenida = ({ onClose }) => {
  return (
    <div className="overlay-bienvenida">
      <div className="overlay-bienvenida-content">
        <img
          src={process.env.PUBLIC_URL + '/Logo/logo-nuevo-Garden-1 1.png'}
          alt="Logo Garden"
          className="overlay-bienvenida-logo"
        />
    
        <button className="overlay-bienvenida-btn" onClick={onClose}>
          Conocer más
        </button>
      </div>
    </div>
  );
};

export default OverlayBienvenida; 